import {
    Positionable,
    ReelModel,
    ReelModelDelegate,
    ReelModelState,
    ReelModelSymbolData
} from "../../framework/reel/ReelModel";
import {MentalLayerSet, MentalReelAreaView} from "./MentalReelAreaView";
import {Mental} from "../Mental";
import {MentalSymbol, MentalSymbolStates} from "./MentalSymbol";

export class MentalReel implements ReelModelDelegate {
    public model: ReelModel;
    public layerSet: MentalLayerSet;
    public position: PIXI.ObservablePoint;
    public isSpecialSymbolReel: boolean = false;
    private _id: number;

    constructor(controller: MentalReelAreaView, id: number) {
        this._id = id;
        this.layerSet = new MentalLayerSet("Reel_" + id);
        this.isSpecialSymbolReel = (id === 3 || id === 1);
        this.model = new ReelModel(id, this, true);
        this.position = new PIXI.ObservablePoint(this.onPosition, this);
    }

    public onPosition() {
        const posY = (this._id === 1 || this._id === 3) ? this.position.y + 198 / 2 : this.position.y;
        this.layerSet.position.set(this.position.x, posY);
    }

    public createSymbol(symbolName: string, state: ReelModelState, position: number): Positionable {
        let symbol: MentalSymbol = Mental.graphicsPool.getSymbolPool(symbolName).withdraw();
        if (state == ReelModelState.SPIN) {
            symbol.setState(MentalSymbolStates.SPIN);
        } else {
            symbol.setState(MentalSymbolStates.NORMAL);
        }
        this.layerSet.addLayerSet(symbol.layerSet);
        return symbol;
    }

    public removeSymbol(symbolData: ReelModelSymbolData, state: ReelModelState = ReelModelState.IDLE): void {
        const symbol = <MentalSymbol>symbolData.positionable;
        symbol.clear();
        this.layerSet.removeLayerSet(symbol.layerSet);
        Mental.graphicsPool.getSymbolPool(symbol.symbolName).deposit(symbol);
    }

    public getAllVisibleSymbols(ofType?: string): MentalSymbol[] {
        const result = [];
        for (let symbolData of this.model.getAllVisibleStopSymbols()) {
            if (ofType != undefined) {
                if (ofType == symbolData.name) {
                    result.push(<MentalSymbol>symbolData.positionable);
                }
            } else {
                result.push(<MentalSymbol>symbolData.positionable);
            }
        }
        return result;
    }

    /**
     * function to get all stop symbols with enhancer symbols
     * @param ofType
     */
    public getAllVisibleStopSymbolsWithEnhancerSymbols(ofType?: string): MentalSymbol[] {
        const result = [];
        for (let symbolData of this.model.getAllVisibleStopSymbolsWithEnhancerSymbols()) {
            if (ofType != undefined) {
                if (ofType == symbolData.name) {
                    result.push(<MentalSymbol>symbolData.positionable);
                }
            } else {
                result.push(<MentalSymbol>symbolData.positionable);
            }
        }
        return result;
    }
}